<template>
  <div class="conditions-list">
    <v-row>
      <v-col v-for="condition in conditionsList" :key='condition.key' cols="12" md="4" lg="4" sm="4">
        <div class="condition-item"
             :class="condition.checked ? 'selected' : ''"
             @click="condition.checked = !condition.checked"
        >
          <div v-if="condition.description !== false">
            <div v-if="isMobile">
              <v-btn class="mx-2 condition-desc" fab dark x-small color="#e2e9fb" @click.stop="condition.infoDialog = true">
                <v-icon color="#456ddd">mdi-help</v-icon>
              </v-btn>
              <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="condition.infoDialog">
                <v-card>
                  <v-card-title class="display-1">{{ condition.name }}</v-card-title>
                  <v-card-text class="headline black--text" >
                    <v-row>
                      <v-col><p>{{ condition.description }}</p></v-col>
                    </v-row>
                    <v-row>
                      <v-col><v-btn @click="condition.infoDialog = false" color="primary">Закрыть</v-btn></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn class="mx-2 condition-desc" fab dark x-small color="#e2e9fb">
                <v-tooltip top max-width="700px" content-class="tooltip-wrapper">
                  <template v-slot:activator="{ on }">
                    <v-icon color="#456ddd" v-on="on" @click.stop="'return false'" >mdi-help</v-icon>
                  </template>
                  <span>{{ condition.description }}</span>
                </v-tooltip>
              </v-btn>
            </div>
          </div>
          <span :class='condition.checked ? condition.icons.hover : condition.icons.default' class="hp-icon" ></span>
          <p class="subtitle-1">{{ condition.name }}</p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="start">
        <v-btn color="primary" @click="goNext">Применить</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'TargetOrganDamages',
  data: function () {
    return {
      conditionsList: [
        {
          key: 1,
          name: 'Цереброваскулярная болезнь',
          icons: {
            default: 'hp-icon-cerebrovascular_01',
            hover: 'hp-icon-cerebrovascular_02'
          },
          // checked: false,
          checked: this.$store.getters.clinicalConditions.filter(function (elem) {return elem.key == 1}).length > 0 ? true : false,
          description: 'Ишемический инсульт, кровоизлияние в мозг, транзиторная ишемическая атака',
          infoDialog: false
        },
        {
          key: 2,
          name: 'Ишемическая болезнь сердца',
          icons: {
            default: 'hp-icon-coronary_01',
            hover: 'hp-icon-coronary_02'
          },
          // checked: false,
          checked: this.$store.getters.clinicalConditions.filter(function (elem) {return elem.key == 2}).length > 0 ? true : false,
          description: 'Инфаркт миокарда, стенокардия, коронарная реваскуляризация методом чрескожного коронарного вмешательства или аортокоронарного шунтирования',
          infoDialog: false
        },
        {
          key: 3,
          name: 'Сердечная недостаточность',
          icons: {
            default: 'hp-icon-heart-failure_01',
            hover: 'hp-icon-heart-failure_02'
          },
          // checked: false,
          checked: this.$store.getters.clinicalConditions.filter(function (elem) {return elem.key == 3}).length > 0 ? true : false,
          description: '2-3 стадии по Василенко-Стражеско',
          infoDialog: false
        },
        {
          key: 4,
          name: 'Поражение периферических артерий',
          icons: {
            default: 'hp-icon-peripheral_01',
            hover: 'hp-icon-peripheral_02'
          },
          // checked: false,
          checked: this.$store.getters.clinicalConditions.filter(function (elem) {return elem.key == 4}).length > 0 ? true : false,
          description: false,
          infoDialog: false
        },
        {
          key: 5,
          name: 'Хронические болезни почек',
          icons: {
            default: 'hp-icon-kidney_01',
            hover: 'hp-icon-kidney_02'
          },
          // checked: false,
          checked: this.$store.getters.clinicalConditions.filter(function (elem) {return elem.key == 5}).length > 0 ? true : false,
          description: '> 4 стадии; протеинурия (>300 мг в сутки)',
          infoDialog: false
        },
        {
          key: 6,
          name: 'Тяжелая ретинопатия',
          icons: {
            default: 'hp-icon-retinopathy_01',
            hover: 'hp-icon-retinopathy_02'
          },
          // checked: false,
          checked: this.$store.getters.clinicalConditions.filter(function (elem) {return elem.key == 6}).length > 0 ? true : false,
          description: 'Кровоизлияния или экссудаты, отек диска зрительного нерва',
          infoDialog: false
        }
      ]
    }
  },
  methods: {
      goNext: function () {
        let checkedDamages = this.conditionsList.filter(function (elem) { return elem.checked == true; })
        this.$emit('clinicalConditionsAreSet', checkedDamages)
      }
  },
  computed: {
    isMobile: function () {
      return screen.width < 600
    },
  },
  created() {
      // this.isMobile = screen.width < 600
  }
}
</script>

<style scoped lang="scss">
  .conditions-list {
    padding: 5px;
  }
  .condition-item {
    cursor: pointer;
    transition: background 0.7s ease;
    text-align: center;
    padding: 7px 0px;
    border-radius: 5px;
    box-sizing: border-box;
    position: relative;
    background: rgba(0,0,0,0.03);
    .condition-desc {
      position: absolute;
      top: 0px;
      right: -8px;
      width: 25px;
      height: 25px;
      &:hover:before {
        color: red;
      }
    }
    .hp-icon {
      font-size: 3rem;
      color: #858585;
    }
    &.selected {
      box-shadow: 0px 0px 4px 1px rgba(69, 109, 221, 0.4);
      .hp-icon {
        color: #456ddd
      }
    }
    &:hover {
      background: rgba(0,0,0,0.07);
      /*border: 1px dashed #456ddd;*/
      .hp-icon {
        color: #456ddd;
      }
    }
  }
</style>
